import Divider from './Divider';

const TableOfContentsLeftNav = ({ title, tocHeaders }: { title: string; tocHeaders: string[] }) => {
  return (
    /* This top qty assumes all of our navbars are 70px tall, which is true as of Oct 2025 */
    <div className='hidden sm:block relative z-10 bg-gray-100 max-w-[240px] w-[240px] -ml-2'>
      {/* Sticky (not fixed) so it stays bound within this grid column's own height, which ends
       * where the page content ends - otherwise a fixed panel keeps painting over whatever
       * scrolls underneath it, including the footer. `relative z-10` on the outer wrapper (not
       * just this inner panel) is required so its own gray background paints above the z-0
       * absolutely-positioned header image from ContentfulContentPageHeader/ContentfulLandingPageHeader
       * - a `position: static` element with no z-index always paints *below* any positioned
       * sibling/ancestor overlap, even one with z-index: 0, regardless of DOM order. */}
      <div className='sticky top-[0px] w-[240px] p-3'>
        <h5 className='mt-3 mtb-2 font-header text-base leading-6 font-semibold'>{title}</h5>
        <Divider className='!w-18 mt-2' />
        <div className='flex flex-col gap-2 text-sm'>
          {tocHeaders.map((header) => (
            <div>
              <a
                className='hover:underline hover:text-brand-500'
                href={
                  // Ensure window exists before use to avoid crashing the Vite build for static pages
                  typeof window !== 'undefined' ?
                    `${window.location.pathname}#${header.replaceAll(' ', '_')}`
                  : ''
                }
              >
                {header}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableOfContentsLeftNav;
